import { useFormContext } from 'react-hook-form';
import {
  GroupType,
  OptionType,
} from '../../../../../../../../CommonComponents/OPL/Select/BaseSelect/types';
import { useAccountFormContext } from '../../context/useAccountFormContext';
import { OwnerModelDTO } from '../../../../../../api/useAccountsQuery';

export const useAccountOwnership = () => {
  const { watch } = useFormContext();

  const accountType = watch('bankAccount.AccountType');

  const {
    options: { OwnerOptions, JointOwnerOptions, AccountTypeOptions },
  } = useAccountFormContext();

  const accountOptions = AccountTypeOptions.find(option => option.AccountType === accountType);

  const hasJointOptions = accountOptions?.AllowsJointOwnership;
  const hasTrustOptions = accountOptions?.AllowsTrustOwnership;
  const hasBusinessOptions = accountOptions?.AllowsBusinessOwnership;

  const getOptions = () => {
    return {
      People: hasJointOptions ? [...JointOwnerOptions.People] : [...OwnerOptions.People],
      Trusts: hasTrustOptions && OwnerOptions.Trusts ? [...OwnerOptions.Trusts] : null,
      Businesses:
        hasBusinessOptions && OwnerOptions.Businesses ? [...OwnerOptions.Businesses] : null,
    };
  };

  const ownerOptions = getOptions();

  return {
    options: Object.keys(ownerOptions).map(key => ({
      label: key,
      options: (ownerOptions[key] || []).map((owner, ind) => ({
        value: owner.Id,
        label: owner.Name,
      })),
    })) as GroupType<OptionType<string>>[],
    ownerOptions: Object.keys(ownerOptions)
      .map(key => ownerOptions[key])
      .flat() as OwnerModelDTO[],
    allowsUnequalOwnership: accountOptions ? accountOptions.AllowsUnequalOwnership : false,
  };
};
